exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hover-4-wrapper[data-v-5c13555a]{width:210px;padding-bottom:10px}", ""]);

// exports
